
import axios from "axios";
import { store } from "store";
import { OutputBaseProps, PaginationProps } from "utils/types/API";
import { GroupUserItemProps } from ".";
import { loading, index, options } from "store/group-user";

interface ApiGroupUserInputProps {
    page?: number;
    pageSize?: number;
    q?: string;
}

type ApiGroupUserOutputProps = OutputBaseProps<{ list: GroupUserItemProps[]; pagination?: PaginationProps; }>

export const apiGroupUserIndex = async (data: ApiGroupUserInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiGroupUserOutputProps>("/api/groups", { params: data }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(index({ data: res.data.list, pagination: res.data.pagination }));
    }
    return res;
};

export const apiGroupUserOptions = async (data: { q?: string; }) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiGroupUserOutputProps>("/api/groups", { params: { ...data, fields: "id,code,name" } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(options({ data: res.data.list }));
    }
    return res;
};